// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ac824f0","455":"4e9535ae","488":"0d5933d4"}[chunkId] + ".chunk.js";
};